// Strings locales del módulo Nodos y Shards (docs/08): sin literales sueltos en JSX.
// Las claves de navegación viven en i18n/es.ts (es.nav.nodes) y NO se duplican aquí.
export const nodesI18n = {
  page: {
    title: "Nodos y shards",
    description:
      "Topología de la plataforma: nodos, su peso en el reparto y los usuarios asignados a cada uno.",
  },
  filter: {
    searchLabel: "Buscar nodo",
    searchPlaceholder: "Buscar por nombre o URL",
    statusLabel: "Filtrar por estado",
    all: "Todos",
  },
  actions: {
    create: "Nuevo nodo",
    edit: "Editar nodo",
    delete: "Dar de baja",
    reassign: "Reasignar usuario",
    viewAssignments: "Ver asignaciones",
    backToNodes: "Volver a nodos",
    drain: "Drenar nodo",
    rebalance: "Rebalancear",
  },
  columns: {
    name: "Nombre",
    baseUrl: "URL base",
    region: "Región",
    weight: "Peso",
    status: "Estado",
    users: "Usuarios",
    lastHeartbeat: "Último latido",
  },
  status: {
    active: "Activo",
    draining: "Drenando",
    down: "Caído",
    disabled: "Deshabilitado",
  },
  fields: {
    name: "Nombre",
    namePlaceholder: "p. ej. node-eu-01",
    baseUrl: "URL base",
    baseUrlPlaceholder: "https://n01.cluster.ejemplo.com",
    region: "Región",
    regionPlaceholder: "p. ej. eu-west-1 (opcional)",
    weight: "Peso",
    weightHint: "Proporción de usuarios que recibe frente a los demás nodos (por defecto 100).",
    capacity: "Capacidad",
    capacityHint: "Informativa: no participa en el reparto.",
    status: "Estado",
  },
  reassign: {
    title: "Reasignar usuario a un nodo",
    userLabel: "Usuario",
    userPlaceholder: "ID (usr_…) o identificador usuario.dominio",
    userHint: "La asignación pasa a estrategia manual y persiste hasta una nueva reasignación.",
    nodeLabel: "Nodo destino",
    submit: "Reasignar",
  },
  assignments: {
    title: "Asignaciones del nodo",
    columns: {
      user: "Usuario",
      strategy: "Estrategia",
      assignedAt: "Asignado",
      previousNode: "Nodo anterior",
      reassignedAt: "Reasignado",
    },
    empty: "Este nodo no tiene usuarios asignados.",
    emptyDescription: "Cuando se asignen usuarios a este nodo aparecerán aquí.",
  },
  strategy: {
    "consistent-hash": "Hash consistente",
    "least-loaded": "Menos cargado",
    manual: "Manual",
  },
  empty: {
    title: "Aún no hay nodos",
    description: "Registra el primer nodo de la plataforma para empezar a asignar usuarios.",
  },
  delete: {
    title: "Dar de baja el nodo",
    message: "Se eliminará el nodo de la topología. Solo es posible si no aloja usuarios.",
    confirm: "Dar de baja",
  },
  validation: {
    nameRequired: "Escribe el nombre del nodo.",
    baseUrlRequired: "Escribe la URL base.",
    baseUrlFormat: "Debe ser una URL http(s) válida.",
    weightRange: "El peso debe ser un entero mayor o igual a 0.",
    capacityRange: "La capacidad debe ser un entero mayor o igual a 0.",
    userRequired: "Indica el usuario a reasignar.",
    nodeRequired: "Elige el nodo destino.",
  },
  toast: {
    created: "Nodo creado",
    updated: "Nodo actualizado",
    deleted: "Nodo dado de baja",
    reassigned: "Usuario reasignado",
    drained: "Nodo en drenado",
    rebalanced: "Rebalanceo aplicado",
  },
  drainDialog: {
    title: "Drenar nodo",
    message:
      "El nodo dejará de recibir asignaciones nuevas; sus usuarios se reubicarán al rebalancear. ¿Continuar?",
    confirm: "Drenar",
  },
  rebalanceDialog: {
    title: "Rebalancear usuarios",
    message:
      "Reubica a los usuarios de nodos drenando o caídos hacia nodos activos, y marca como caídos los nodos sin latido reciente.",
    confirm: "Rebalancear ahora",
  },
  none: "—",
} as const
